// extracted by mini-css-extract-plugin
module.exports = {"yearSelector":"YearSelector_yearSelector__2M8JT"};